var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "apartment", on: { click: _vm.handleApartmentClick } },
    [
      _vm.apartment.image
        ? _c("div", { staticClass: "apartment__image" }, [
            _c("img", {
              attrs: {
                src: _vm.apartment.image,
                alt: "Osiedle Tuleckie " + _vm.apartment.id
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "apartment__title" }, [
        _c("div", [
          _c("div", { staticClass: "text-uppercase apartment__title__top" }, [
            _vm._v("Numer lokalu")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title-1 apartment__title__number" }, [
            _vm._v(_vm._s(_vm.apartment.id))
          ])
        ]),
        _vm._v(" "),
        !_vm.isSold && _vm.apartment.pdf && !_vm.hideDetails
          ? _c(
              "a",
              {
                staticClass: "btn btn--clickable btn--sm",
                attrs: { href: _vm.apartment.pdf, target: "_blank" }
              },
              [_vm._v("\n      Szczegóły")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "apartment__details" }, [
        _c("div", { staticClass: "apartment__detail" }, [
          _c("div", { staticClass: "apartment__detail__label" }, [
            _vm._v("Powierzchnia domu")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "apartment__detail__val" }, [
            _vm._v("\n        " + _vm._s(_vm.apartment.area) + "m"),
            _c("sup", [_vm._v("2")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "apartment__detail" }, [
          _c("div", { staticClass: "apartment__detail__label" }, [
            _vm._v("Liczba pokoi")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "apartment__detail__val" }, [
            _vm._v(_vm._s(_vm.apartment.rooms))
          ])
        ]),
        _vm._v(" "),
        _vm.apartment.garden.length > 1
          ? _c("div", { staticClass: "apartment__detail" }, [
              _c("div", { staticClass: "apartment__detail__label" }, [
                _vm._v("Ogród")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "apartment__detail__val" }, [
                _vm._v("\n        " + _vm._s(_vm.apartment.garden) + "m"),
                _c("sup", [_vm._v("2")])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.apartment.terrace.length > 1
          ? _c("div", { staticClass: "apartment__detail" }, [
              _c("div", { staticClass: "apartment__detail__label" }, [
                _vm._v("Taras")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "apartment__detail__val" }, [
                _vm._v("\n        " + _vm._s(_vm.apartment.terrace) + "m"),
                _c("sup", [_vm._v("2")])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "apartment__detail apartment__detail--top" }, [
          _c("div", { staticClass: "apartment__detail__label" }, [
            _vm._v("Cena")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "apartment__detail__val" }, [
            _c("div", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.isSold ? "- zł" : _vm.apartment.price) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            !_vm.isSold
              ? _c(
                  "div",
                  {
                    staticStyle: { "font-size": "12px", "text-align": "right" }
                  },
                  [
                    _vm._v("\n          " + _vm._s(_vm.pricePerSqm) + " zł/m"),
                    _c("sup", [_vm._v("2")])
                  ]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "apartment__bottom" }, [
        _c(
          "div",
          { class: "apartment__status apartment__status--" + _vm.status },
          [_vm._v("\n      " + _vm._s(_vm.apartment.status) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "apartment__local",
            on: { click: _vm.handlePriceHistoryClick }
          },
          [
            _c(
              "svg",
              {
                staticClass: "lucide lucide-history-icon lucide-history",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
                  }
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M3 3v5h5" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M12 7v5l4 2" } })
              ]
            )
          ]
        ),
        _vm._v(" "),
        !_vm.isSold && _vm.apartment.pdf
          ? _c(
              "a",
              {
                staticClass: "apartment__local",
                attrs: { href: _vm.apartment.pdf, target: "_blank" }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M18.4252 19.6258C18.5122 19.5557 18.5681 19.4482 18.5681 19.3277C18.5681 19.3243 18.5681 1.91489 18.5681 1.91489C18.5681 1.70334 18.3966 1.53191 18.1851 1.53191H7.10499C6.83175 0.645804 6.00528 0 5.03073 0C4.07185 0 3.23282 0.639013 2.95682 1.53191H1.72966C1.5181 1.53191 1.34668 1.70334 1.34668 1.91489V23.617C1.34668 23.8286 1.5181 24 1.72966 24H13.8924C14.0162 24 14.1236 23.9442 14.1938 23.8573L18.4252 19.6258ZM14.2787 22.6891V19.7106H17.2571L14.2787 22.6891ZM5.03073 0.765957C5.57522 0.765957 6.04802 1.0777 6.28088 1.53191H3.78048C4.01558 1.075 4.4941 0.765957 5.03073 0.765957ZM2.11264 2.29787H6.43499V4.97872C6.43499 5.33071 6.14867 5.61702 5.79669 5.61702C5.44471 5.61702 5.15839 5.33071 5.15839 4.97872V3.44681C5.15839 3.23525 4.98697 3.06383 4.77541 3.06383C4.56385 3.06383 4.39243 3.23525 4.39243 3.44681V4.97872C4.39243 5.753 5.02241 6.38298 5.79669 6.38298C6.57097 6.38298 7.20094 5.753 7.20094 4.97872V2.29787H17.8021V18.9447H13.8957C13.6842 18.9447 13.5127 19.1161 13.5127 19.3277V23.234H2.11264V2.29787Z",
                        fill: "black"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M15.1209 17.6427C15.3325 17.6427 15.5039 17.4712 15.5039 17.2597C15.5039 17.0481 15.3325 16.8767 15.1209 16.8767H4.79313C4.58158 16.8767 4.41016 17.0481 4.41016 17.2597C4.41016 17.4712 4.58158 17.6427 4.79313 17.6427H15.1209Z",
                        fill: "black"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M4.79313 15.3446H15.1209C15.3325 15.3446 15.5039 15.1731 15.5039 14.9616C15.5039 14.75 15.3325 14.5786 15.1209 14.5786H4.79313C4.58158 14.5786 4.41016 14.75 4.41016 14.9616C4.41016 15.1731 4.58158 15.3446 4.79313 15.3446Z",
                        fill: "black"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M4.79313 13.0467H15.1209C15.3325 13.0467 15.5039 12.8753 15.5039 12.6637C15.5039 12.4522 15.3325 12.2808 15.1209 12.2808H4.79313C4.58158 12.2808 4.41016 12.4522 4.41016 12.6637C4.41016 12.8753 4.58158 13.0467 4.79313 13.0467Z",
                        fill: "black"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M4.79313 10.7489H15.1209C15.3325 10.7489 15.5039 10.5774 15.5039 10.3659C15.5039 10.1543 15.3325 9.98291 15.1209 9.98291H4.79313C4.58158 9.98291 4.41016 10.1543 4.41016 10.3659C4.41016 10.5774 4.58158 10.7489 4.79313 10.7489Z",
                        fill: "black"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M4.79313 8.45102H15.1209C15.3325 8.45102 15.5039 8.27959 15.5039 8.06804C15.5039 7.85648 15.3325 7.68506 15.1209 7.68506H4.79313C4.58158 7.68506 4.41016 7.85648 4.41016 8.06804C4.41016 8.27959 4.58158 8.45102 4.79313 8.45102Z",
                        fill: "black"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M20.2278 1.53186H19.7171C19.5056 1.53186 19.3342 1.70328 19.3342 1.91484C19.3342 2.1264 19.5056 2.29782 19.7171 2.29782H19.8448V23.234H15.756C15.5445 23.234 15.373 23.4054 15.373 23.617C15.373 23.8285 15.5445 23.9999 15.756 23.9999H20.2278C20.4393 23.9999 20.6108 23.8285 20.6108 23.617V1.91484C20.6108 1.70328 20.4393 1.53186 20.2278 1.53186Z",
                        fill: "black"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M22.2706 1.53186H21.7599C21.5484 1.53186 21.377 1.70328 21.377 1.91484C21.377 2.1264 21.5484 2.29782 21.7599 2.29782H21.8876V23.234H21.7599C21.5484 23.234 21.377 23.4054 21.377 23.617C21.377 23.8285 21.5484 23.9999 21.7599 23.9999H22.2706C22.4821 23.9999 22.6535 23.8285 22.6535 23.617V1.91484C22.6535 1.70328 22.4821 1.53186 22.2706 1.53186Z",
                        fill: "black"
                      }
                    })
                  ]
                )
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32d09ca3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d09ca3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/partials/ApartmentCard.vue
// module id = 49
// module chunks = 0